(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reborn-dealer-application"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function isValidNorwegianOrgNumber(value) {
      if (!/^[0-9]{9}$/.test(value)) return false;
      var weights = [3, 2, 7, 6, 5, 4, 3, 2];
      var sum = 0;
      for (var i = 0; i < 8; i++) {
        sum += parseInt(value.charAt(i), 10) * weights[i];
      }
      var remainder = sum % 11;
      var control = remainder === 0 ? 0 : 11 - remainder;
      if (control === 10) return false;
      return control === parseInt(value.charAt(8), 10);
    }

    function bindOrgNumberValidation(input) {
      if (input.dataset.orgValidationBound) return;
      input.dataset.orgValidationBound = 'true';

      function validate() {
        var digits = input.value.replace(/\D/g, '').slice(0, 9);
        if (digits !== input.value) input.value = digits;

        if (digits.length === 0) {
          input.setCustomValidity('');
        } else if (digits.length !== 9 || !isValidNorwegianOrgNumber(digits)) {
          input.setCustomValidity('Skriv inn et gyldig 9-sifret organisasjonsnummer (kontrollsifferet stemmer ikke).');
        } else {
          input.setCustomValidity('');
        }
      }

      input.addEventListener('input', validate);
      input.addEventListener('blur', function () {
        input.classList.add('reborn-dealer-application__org-input--touched');
        validate();
      });
    }

    document.querySelectorAll('.reborn-dealer-application__org-input').forEach(bindOrgNumberValidation);

    function bindBusinessTypeValidation(group) {
      if (group.dataset.businessTypeBound) return;
      group.dataset.businessTypeBound = 'true';

      var form = group.closest('form');
      if (!form) return;

      // Everything below is looked up at the moment it is needed rather than
      // captured here.
      //
      // The previous version held a static NodeList from querySelectorAll and
      // attached one change listener per checkbox. When the section's DOM was
      // re-rendered — Section Rendering, a theme-editor update, any morph —
      // those elements were replaced. The captured list then pointed at
      // detached nodes that could never be checked, and the replacement inputs
      // carried no listeners at all. Because businessTypeBound stayed on the
      // surviving group element, the code never re-bound either.
      //
      // The result was the reported bug exactly: all four options visibly
      // ticked, "Velg minst én type virksomhet." refusing to clear, and submit
      // blocked no matter what the applicant did.
      function checkboxes() {
        return group.querySelectorAll('.checkbox__input');
      }

      function errorEl() {
        return group.querySelector('[data-business-type-error]');
      }

      function hasSelection() {
        var found = false;
        checkboxes().forEach(function (checkbox) {
          if (checkbox.checked) found = true;
        });
        return found;
      }

      // Delegated to the group, which survives its children being replaced.
      group.addEventListener('change', function (event) {
        if (!event.target || !event.target.classList) return;
        if (!event.target.classList.contains('checkbox__input')) return;
        var error = errorEl();
        if (error && hasSelection()) error.hidden = true;
      });

      form.addEventListener('submit', function (event) {
        if (hasSelection()) return;
        event.preventDefault();
        var error = errorEl();
        if (error) error.hidden = false;
        var first = checkboxes()[0];
        if (first) first.focus();
      });
    }

    document.querySelectorAll('[data-business-type-group]').forEach(bindBusinessTypeValidation);

    if (!window.__rebornDealerScrollBound) {
      window.__rebornDealerScrollBound = true;
      document.addEventListener('click', function (event) {
        var link = event.target.closest('a[href="#reborn-dealer-soknad"]');
        if (!link) return;
        var target = document.getElementById('reborn-dealer-soknad');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.pushState) {
          window.history.pushState(null, '', '#reborn-dealer-soknad');
        }
      });
    }

    function bindTermsTrigger(trigger) {
      if (trigger.dataset.termsBound) return;
      trigger.dataset.termsBound = 'true';
      trigger.addEventListener('click', function () {
        var dialogId = trigger.getAttribute('aria-controls');
        var dialog = dialogId && document.getElementById(dialogId);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      });
    }

    function bindTermsDialog(dialog) {
      if (dialog.dataset.termsBound) return;
      dialog.dataset.termsBound = 'true';
      var closeBtn = dialog.querySelector('[data-terms-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dialog.close();
        });
      }
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    document.querySelectorAll('[data-terms-trigger]').forEach(bindTermsTrigger);
    document.querySelectorAll('.reborn-dealer-terms-dialog').forEach(bindTermsDialog);

    document.querySelectorAll('.reborn-dealer-application__terms-timestamp').forEach(function (input) {
      if (input.dataset.timestampBound) return;
      input.dataset.timestampBound = 'true';
      var form = input.closest('form');
      if (!form) return;
      form.addEventListener('submit', function () {
        input.value = new Date().toISOString();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
